import { SkeletonBlock } from '../../SkeletonBlock/SkeletonBlock';

export function SkeletonStatChip() {
  return <SkeletonBlock className="h-[12px] w-[23px] shrink-0 rounded-[16px]" variant="sunked" />;
}
